import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'
import store from '../../store/index.js'

export default {
  getAllteams () {
    var target = urls.TEAM_URL
    return Vue.http.get(target)
  },
  getAllteamsForLeague (leagueName) {
    var target = urls.TEAM_URL + '?league=' + leagueName
    return Vue.http.get(target)
  },
  getAllteamsForClub (clubId) {
    var target = urls.TEAM_URL + '?club=' + clubId
    return Vue.http.get(target)
  },
  getPublishedTeams () {
    var target = urls.TEAM_URL + '?status=1'
    return Vue.http.get(target)
  },
  getOwnPublishedTeams () {
    let currentUserId = store.getters.currentUser.id
    var target = urls.TEAM_URL + '?status=1&coach=' + currentUserId
    return Vue.http.get(target)
  },
  getDetailedTeam (id) {
    var target = urls.TEAM_URL + id + '/'
    return Vue.http.get(target)
  },
  getFullDetailedTeam (id) {
    var target = urls.TEAM_URL + id + '/fulldetail/'
    return Vue.http.get(target)
  },
  getRosterList () {
    var target = urls.ROSTER_LIST_URL + '?ruleset=BB_2020'
    return Vue.http.get(target)
  },
  getDetailedRoster (id) {
    var target = urls.ROSTER_LIST_URL + id + '/'
    return Vue.http.get(target)
  },
  createTeam (team) {
    var body = JSON.stringify(team)
    var target = urls.TEAM_URL
    return Vue.http.post(target, body, {'headers': authHeaders.getAuthHeaders()})
  },
  deleteTeam (id) {
    let target = urls.TEAM_URL + id + '/'
    return Vue.http.delete(target, {'headers': authHeaders.getAuthHeaders()})
  },
  publishTeam (id) {
    let target = urls.TEAM_URL + id + '/publish/'
    return Vue.http.patch(target, '', {'headers': authHeaders.getAuthHeaders()})
  },
  updateTeam (id, datas) {
    let target = urls.TEAM_URL + id + '/'
    let body = JSON.stringify(datas)
    return Vue.http.patch(target, body, {'headers': authHeaders.getAuthHeaders()})
  },
  downloadPDF (id) {
    return Vue.http.get(urls.TEAM_URL + id + '/pdf/', {responseType: 'arraybuffer'})
  },
  finishSeason (id) {
    return Vue.http.get(urls.TEAM_URL + id + '/end_of_season/')
  },
  getTeamsInfosForMatchReport (id) {
    return Vue.http.get(urls.TEAM_URL + 'infos_for_report/?report_id=' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/team.api.js